import React from 'react';

const personalInfoContent = [
  { meta: 'first name', metaInfo: 'Qaush' },
  { meta: 'last name', metaInfo: 'Qestaj' },
  { meta: 'Age', metaInfo: '25 Years' },
  { meta: 'Nationality', metaInfo: 'Kosovar' },
  { meta: 'phone', metaInfo: '+49 157 53064407' },
  { meta: 'Address', metaInfo: 'Leverkusen, Germany' },
  { meta: 'Open to work', metaInfo: 'Yes' },
  { meta: 'Email', metaInfo: 'qaush.qestaj@gmail.com' },
  { meta: 'LinkedIn', metaInfo: 'Qaush Qestaj' },
  { meta: 'languages', metaInfo: 'Albanian, English, German' },
];

const PersonalInfo = () => {
  return (
    <ul className="about-list list-unstyled open-sans-font">
      {personalInfoContent.map((val, i) => (
        <li key={i}>
          <span className="title">{val.meta}: </span>
          <span className="value d-block d-sm-inline-block d-lg-block d-xl-inline-block">
            {val.metaInfo}
          </span>
        </li>
      ))}
    </ul>
  );
};

export default PersonalInfo;
